import Hero from "./components/Hero";
import About from "./components/About";
import Contact from "./components/Contact";

export default function App() {
  return (
    <div className="App font-Nunito">
      <Hero />
      <About />
      <Contact />
    </div>
  );
}
